import { render } from "./section_6.vue?vue&type=template&id=5e15072e"
import script from "./section_6.vue?vue&type=script&lang=js"
export * from "./section_6.vue?vue&type=script&lang=js"

import "./section_6.vue?vue&type=style&index=0&id=5e15072e&lang=css"
script.render = render

export default script